import { render, staticRenderFns } from "./HomeEvents.vue?vue&type=template&id=3d95a7ae"
import script from "./HomeEvents.vue?vue&type=script&lang=js"
export * from "./HomeEvents.vue?vue&type=script&lang=js"
import style0 from "./HomeEvents.vue?vue&type=style&index=0&id=3d95a7ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports